// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/langtext_teaser_gruen.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.centerAdd {
  text-align: center;
  padding: 20px 0px;
}

.news-text-container h2 {
  font-size: 30px;
  line-height: 46px;
  color: #005790;
  font-weight: normal;
  margin: 48px 0px 37px;
}

.col-lg-6 {
  padding-left: 0px;
}

.addLeft .col-lg-6 {
  padding-left: 15px;
}

.addLeft > :nth-last-child(2),
.addRight > :nth-last-child(2) {
  margin-bottom: 0;
}

.teaserConInner {
  padding: 72px 65px 30px 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right;
  display: flex;
  max-width: none;
  width: auto;
  justify-content: space-between;
  transition: transform 0.4s;
  position: relative;
  transform: translateY(0);
}
.teaserConInner:before {
  display: block;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.1;
  transition: opacity 0.4s;
}
@media (max-width: 1330px) {
  .teaserConInner {
    padding-right: 40px;
  }
}
@media (max-width: 1060px) {
  .teaserConInner {
    padding-right: 65px;
  }
}
@media (max-width: 380px) {
  .teaserConInner {
    padding: 72px 15px 30px 15px;
  }
}
.teaserConInner .seminarFakelink {
  position: relative;
  display: inline-block;
  font-size: 24px;
  line-height: 29px;
  font-weight: bold;
  margin-bottom: 23px;
  margin-top: 22px;
}
.teaserConInner .seminarFakelink:after {
  position: absolute;
  bottom: -10px;
  left: 0;
  content: "";
  height: 2px;
  width: 30%;
  background-color: #ffffff;
  transition: width 0.4s;
  display: block;
}
.teaserConInner:hover {
  transform: translateY(-20px);
}
.teaserConInner:hover:before {
  opacity: 0;
}
.teaserConInner:hover .teaserImg {
  transform: scale(1.02);
}
.teaserConInner:hover .seminarFakelink:after {
  width: 100%;
}
.teaserConInner.leftImgTeaser {
  gap: 75px;
}
@media (max-width: 1330px) {
  .teaserConInner.leftImgTeaser {
    gap: 40px;
  }
}
@media (max-width: 1060px) {
  .teaserConInner.leftImgTeaser {
    gap: 75px;
  }
}
@media (max-width: 550px) {
  .teaserConInner.leftImgTeaser {
    gap: 25px;
    flex-wrap: wrap;
  }
}

@media (max-width: 550px) {
  .addLeft .teaserConInner {
    flex-wrap: wrap;
  }
}

.teaserCon {
  float: right;
  width: calc(50% + 177px);
  margin-right: -117px;
  padding-left: 80px;
  padding-bottom: 20px;
}
@media (max-width: 1330px) {
  .teaserCon {
    width: calc(50% + 60px);
    margin-right: 0px;
  }
}
@media (max-width: 1170px) {
  .teaserCon {
    width: calc(50% + 10px);
    padding-left: 30px;
    padding-bottom: 0px;
  }
}
@media (max-width: 1060px) {
  .teaserCon {
    float: none;
    padding-left: 0px;
    width: 100%;
    margin-bottom: 20px;
  }
}
.teaserCon svg {
  position: absolute;
  z-index: -1;
}

.teaserLeftImgWrap {
  position: relative;
}
.teaserLeftImgWrap .flags {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: -35px;
  right: -35px;
  color: #fff;
  z-index: 10;
}
.teaserLeftImgWrap .flags .flag {
  margin-bottom: 10px;
}
.teaserLeftImgWrap .teaserImg {
  min-width: 193px;
  padding-bottom: 30px;
}
@media (max-width: 1200px) {
  .teaserLeftImgWrap .teaserImg {
    min-width: 123px;
  }
}
@media (max-width: 1060px) {
  .teaserLeftImgWrap .teaserImg {
    min-width: 193px;
  }
}
@media (max-width: 600px) {
  .teaserLeftImgWrap .teaserImg {
    min-width: 123px;
  }
}
@media (max-width: 400px) {
  .teaserLeftImgWrap .teaserImg {
    min-width: 193px;
  }
}

.leftImgTeaser p {
  font-size: 18px;
  line-height: 30px;
  margin-bottom: 12px;
}
.leftImgTeaser .greenText,
.leftImgTeaser .productPrice {
  color: #ffffff;
}

.addLeft .teaserCon {
  float: left;
  margin-right: 0px;
  margin-left: -117px;
  padding-left: 0px;
  padding-right: 80px;
}
@media (max-width: 1330px) {
  .addLeft .teaserCon {
    width: calc(50% + 60px);
    margin-left: 0px;
  }
}
@media (max-width: 1170px) {
  .addLeft .teaserCon {
    width: calc(50% + 10px);
    padding-right: 30px;
    padding-bottom: 0px;
  }
}
@media (max-width: 1060px) {
  .addLeft .teaserCon {
    float: none;
    padding-right: 0px;
    width: 100%;
  }
}

.teaserContent {
  align-self: end;
  margin-right: 30px;
  display: flex;
  flex-direction: column;
  color: #ffffff;
  max-width: 100%;
}
.teaserLeftImgWrap + .teaserContent {
  padding-bottom: 30px;
}
@media (max-width: 550px) {
  .teaserLeftImgWrap + .teaserContent {
    padding-bottom: 0;
  }
}
.teaserContent h4 {
  font-size: 30px;
  line-height: 36px;
  font-weight: normal;
}
.teaserContent .flagSeminar {
  margin-top: 50px;
}
.teaserContent .shortText {
  font-size: 18px;
  line-height: 30px;
}
.teaserContent .date,
.teaserContent .meta {
  font-size: 16px;
  line-height: 24px;
}
.teaserContent .date:before,
.teaserContent .meta:before {
  content: "\\ec30";
  font-family: "LineIcons";
  padding-right: 7px;
  font-size: 20px;
  position: relative;
  top: 5px;
}
.teaserContent .date:before {
  content: "\\ea2e";
  top: 4px;
}
.teaserContent .meta:before {
  content: "\\ec8f";
  top: 4px;
}
.teaserContent .meta {
  margin-bottom: 0px;
}
.teaserContent .date {
  margin-bottom: 16px;
}

.teaserCon .teaserConInner:hover:after {
  content: "";
  background-color: transparent;
  height: 20px;
  width: 100%;
  display: block;
  position: absolute;
  bottom: -20px;
  left: 0px;
}

.topicHeader,
.topTipp {
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 4px;
  text-transform: uppercase;
}

.teaserImg {
  max-width: 193px;
  padding-bottom: 42px;
  width: 100%;
  transition: transform 0.4s;
}
.teaserImgWrap {
  position: absolute;
  top: 30px;
  right: 30px;
  height: 170px;
  width: 170px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
@media (max-width: 380px) {
  .teaserImgWrap {
    right: 15px;
  }
}
.teaserImgWrap img {
  max-width: none;
  max-height: 100%;
}

.news-related-links a,
.news-related-files-link a {
  margin-right: 10px;
}

.toContinueReading {
  position: relative;
  min-height: 1045px;
  margin-bottom: 30px;
}

.toContinueReading:after {
  content: "";
  background-image: linear-gradient(0deg, #ffffff 30%, rgba(255, 255, 255, 0) 100%);
  position: absolute;
  height: 850px;
  width: 100%;
  display: block;
  bottom: 0;
}

#main .toContinueReadingModal,
.toContinueReadingModal {
  position: absolute;
  bottom: 0;
  z-index: 5;
  background: white;
  box-shadow: #5f5e5c 0px 0px 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 800px;
  display: flex;
  justify-content: center;
  z-index: 11;
  padding: 78px 15px 40px 15px;
}
@media (max-width: 480px) {
  #main .toContinueReadingModal,
  .toContinueReadingModal {
    padding: 48px 15px 40px;
  }
}
#main .toContinueReadingModal h4,
.toContinueReadingModal h4 {
  font-size: 30px;
  line-height: 46px;
  color: #005790;
  font-weight: normal;
  margin-bottom: 34px;
  text-align: left;
}
#main .toContinueReadingModal img,
.toContinueReadingModal img {
  height: 25px;
  width: auto;
  position: relative;
  top: -2px;
  padding-left: 10px;
}
@media (max-width: 460px) {
  #main .toContinueReadingModal img,
  .toContinueReadingModal img {
    padding-left: 0px;
  }
}
#main .toContinueReadingModal li,
.toContinueReadingModal li {
  font-size: 18px;
  line-height: 30px;
  padding-left: 35px !important;
  text-align: left;
}
@media (max-width: 480px) {
  #main .toContinueReadingModal li,
  .toContinueReadingModal li {
    display: inline-block;
  }
}
#main .toContinueReadingModal ul li:before,
.toContinueReadingModal ul li:before {
  content: none;
}
#main .toContinueReadingModal span:not(.underline):not(.check),
.toContinueReadingModal span:not(.underline):not(.check) {
  display: block;
  width: 100%;
  text-align: center;
}
#main .toContinueReadingModal.toContinueWatchingModal,
.toContinueReadingModal.toContinueWatchingModal {
  bottom: 50%;
  opacity: 1;
  transform: translateX(-50%) translateY(50%);
  transition: all 300ms;
}
#main .toContinueReadingModal.toContinueWatchingModal.hidden,
.toContinueReadingModal.toContinueWatchingModal.hidden {
  opacity: 0;
  transform: translateX(-250%) translateY(50%);
}

.check {
  display: inline-block;
  position: absolute;
  top: 1px;
  left: 5px;
  width: 10px !important;
  height: 20px;
  border-bottom: 2px solid;
  border-right: 2px solid;
  transform: rotate(45deg);
  color: #005790;
  background-color: transparent;
}

.underline {
  position: relative;
}
.underline:after {
  content: "";
  position: absolute;
  left: 0px;
  bottom: -3px;
  height: 1px;
  width: 100%;
  background-color: #3dbea2;
}

.continueAboPrice {
  font-size: 38px;
  line-height: 46px;
  color: #005790;
  margin-top: 46px;
}

.continuePerMonth {
  font-size: 18px;
}

.continueAboButton {
  background: #3dbea2;
  background-image: linear-gradient(270deg, #3DBEA2 50%, #228D76 100%);
  background-size: 200%;
  background-position: 100%;
  transition: all 0.4s;
  padding: 20px;
  margin: 32px 0px 28px;
  display: block;
  text-align: center;
  color: white;
  font-size: 18px;
  line-height: 30px;
  font-weight: bold;
}
.continueAboButton:hover {
  color: white;
  background-position: 0%;
}

.continueAlreadyAbo {
  font-size: 18px;
  line-height: 30px;
}

.continueLogin {
  font-size: 18px;
  line-height: 30px;
  font-weight: bold;
  color: #3dbea2;
  text-align: center;
  display: inline-block;
  margin-top: 10px;
}

.toContinueReadingModalInner {
  text-align: center;
}
.toContinueReadingModalInner li:before {
  display: none !important;
}

#authorModal .modal-content {
  max-width: 724px;
  background: white;
  padding: 70px 15px 15px;
  margin: 40px auto 0px;
  transition: transform 0.3s;
}
@media (max-width: 576px) {
  #authorModal .modal-content {
    margin: 0px auto;
  }
}

#authorModal .modal-dialog {
  transform: none;
}

.authorOpen #authorModal .modal-content {
  transition: transform 0.3s;
}

@keyframes scaleDown {
  0% {
    transform: scale(1);
  }
  90% {
    transform: scale(0.1);
    opacity: 1;
  }
  100% {
    transform: scale(0.1);
    opacity: 0;
  }
}
@keyframes scaleUp {
  0% {
    transform: scale(0.1);
    opacity: 0;
  }
  10% {
    transform: scale(0.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}
.closeAuthor {
  margin: 0 auto 70px;
}

.author .photo {
  text-align: center;
}
.author .photo img {
  border-radius: 50%;
}
.author .description {
  max-width: 465px;
  margin: 0px auto 40px;
}
.author .description .authorName {
  margin: 28px 0px 23px;
}
.author .description p {
  color: #5f5e5c;
}

.toggleLinkAuthor {
  border-bottom: solid #3dbea2 1px;
  padding-bottom: 2px;
  cursor: pointer;
  transition: color 0.4s;
}
.toggleLinkAuthor:hover {
  color: #3dbea2;
}

.advertisementTeaserContainer {
  position: relative;
  top: 0;
  transition: top 400ms;
  width: 300px;
  margin-bottom: 20px;
}
.advertisementTeaserContainer.right {
  float: right;
  margin-left: 50px;
}
.advertisementTeaserContainer.left {
  float: left;
  margin-right: 50px;
}
@media (max-width: 767.98px) {
  .advertisementTeaserContainer {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./build/scss/_news-detail.scss","webpack://./build/scss/_variables.scss","webpack://./build/scss/bootstrap/mixins/_breakpoints.scss"],"names":[],"mappings":"AAaA;EACI,kBAAA;EACA,iBAAA;AAZJ;;AAkBI;EACI,eAAA;EACA,iBAAA;EACA,cCDD;EDEC,mBAAA;EACA,qBAAA;AAfR;;AAoBA;EACI,iBAAA;AAjBJ;;AAoBA;EACI,kBAAA;AAjBJ;;AAuBI;;EACI,gBAAA;AAnBR;;AAuBA;EACI,4BAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,0BAAA;EAGA,aAAA;EAIA,eAAA;EACA,WAAA;EACA,8BAAA;EACA,0BAAA;EAGA,kBAAA;EACA,wBAAA;AA3BJ;AA6BI;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,wBAAA;AA3BR;AA8BI;EAlCJ;IAoCQ,mBAAA;EA5BN;AACF;AA6BI;EAtCJ;IAuCQ,mBAAA;EA1BN;AACF;AA+BI;EA7CJ;IA8CQ,4BAAA;EA5BN;AACF;AA8BI;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AA5BR;AA+BI;EACI,kBAAA;EACA,aAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,yBChGA;EDiGA,sBAAA;EACA,cAAA;AA7BR;AAgCI;EAGI,4BAAA;AAhCR;AAkCQ;EACI,UAAA;AAhCZ;AAmCQ;EACI,sBAAA;AAjCZ;AAoCQ;EACI,WAAA;AAlCZ;AAsCI;EACI,SAAA;AApCR;AAsCQ;EAHJ;IAIQ,SAAA;EAnCV;AACF;AAqCQ;EAPJ;IAQQ,SAAA;EAlCV;AACF;AAoCQ;EAXJ;IAYQ,SAAA;IACA,eAAA;EAjCV;AACF;;AAqDI;EAhBJ;IAiBQ,eAAA;EAjDN;AACF;;AAoDA;EACI,YAAA;EACA,wBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AAjDJ;AAmDI;EAPJ;IAQQ,uBAAA;IACA,iBAAA;EAhDN;AACF;AAiDI;EAXJ;IAYQ,uBAAA;IACA,kBAAA;IACA,mBAAA;EA9CN;AACF;AA+CI;EAhBJ;IAiBQ,WAAA;IACA,iBAAA;IACA,WAAA;IACA,mBAAA;EA5CN;AACF;AA8CI;EACI,kBAAA;EACA,WAAA;AA5CR;;AAgDA;EACI,kBAAA;AA7CJ;AA+CI;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AA7CR;AA+CQ;EACI,mBAAA;AA7CZ;AAiDI;EACI,gBAAA;EACA,oBAAA;AA/CR;AAiDQ;EAJJ;IAKQ,gBAAA;EA9CV;AACF;AAgDQ;EARJ;IASQ,gBAAA;EA7CV;AACF;AA+CQ;EAZJ;IAaQ,gBAAA;EA5CV;AACF;AA8CQ;EAhBJ;IAiBQ,gBAAA;EA3CV;AACF;;AAgDI;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;AA7CR;AAgDI;;EAEI,cC3OA;AD6LR;;AAkDA;EACI,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AA/CJ;AAiDI;EAPJ;IAQQ,uBAAA;IACA,gBAAA;EA9CN;AACF;AA+CI;EAXJ;IAYQ,uBAAA;IACA,mBAAA;IACA,mBAAA;EA5CN;AACF;AA6CI;EAhBJ;IAiBQ,WAAA;IACA,kBAAA;IACA,WAAA;EA1CN;AACF;;AA6CA;EACI,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cC3QI;ED4QJ,eAAA;AA1CJ;AA4CI;EACI,oBAAA;AA1CR;AA4CQ;EAHJ;IAIQ,iBAAA;EAzCV;AACF;AA4CI;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;AA1CR;AA6CI;EACI,gBAAA;AA3CR;AA8CI;EACI,eAAA;EACA,iBAAA;AA5CR;AA+CI;;EAEI,eAAA;EACA,iBAAA;AA7CR;AA+CQ;;EACI,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;AA5CZ;AAgDI;EACI,gBAAA;EACA,QAAA;AA9CR;AAiDI;EACI,gBAAA;EACA,QAAA;AA/CR;AAkDI;EACI,kBAAA;AAhDR;AAmDI;EACI,mBAAA;AAjDR;;AAsDI;EACI,WAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AAnDR;;AAuDA;;EAEI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AApDJ;;AAuDA;EACI,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,0BAAA;AApDJ;AA2DA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAzDJ;AA2DI;EAXJ;IAYQ,WAAA;EAxDN;AACF;AA0DI;EACI,eAAA;EACA,gBAAA;AAxDR;;AA4DA;;EAEI,kBAAA;AAzDJ;;AA6DA;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;AA1DJ;;AA6DA;EACI,WAAA;EAEA,iFAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EAEA,SAAA;AA5DJ;;AA+DA;;EAEI,kBAAA;EAEA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,gCAAA;EACA,SAAA;EACA,2BAAA;EAEA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,4BAAA;AA9DJ;AAgEI;EAlBJ;;IAmBQ,uBAAA;EA5DN;AACF;AA+DI;;EACI,eAAA;EACA,iBAAA;EACA,cCxaD;EDyaC,mBAAA;EACA,mBAAA;EACA,gBAAA;AA5DR;AAoEI;;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AAjER;AAmEQ;EAPJ;;IAQQ,iBAAA;EA/DV;AACF;AAkEI;;EACI,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;AA/DR;AAiEQ;EANJ;;IAOQ,qBAAA;EA7DV;AACF;AAgEI;;EACI,aAAA;AA7DR;AAgEI;;EACI,cAAA;EACA,WAAA;EACA,kBAAA;AA7DR;AAgEI;;EACI,WAAA;EACA,UAAA;EACA,2CAAA;EACA,qBAAA;AA7DR;AA+DQ;;EACI,UAAA;EACA,4CAAA;AA5DZ;;AAiEA;EACI,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,YAAA;EACA,wBAAA;EACA,uBAAA;EACA,wBAAA;EACA,cAAA;EACA,6BAAA;AA9DJ;;AAiEA;EACI,kBAAA;AA9DJ;AAgEI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,yBCrfA;ADubR;;AAkEA;EACI,eAAA;EACA,iBAAA;EACA,cChgBG;EDigBH,gBAAA;AA/DJ;;AAkEA;EACI,eAAA;AA/DJ;;AAkEA;EACI,mBCrgBI;EDsgBJ,oEAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EAEA,aAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAhEJ;AAkEI;EACI,YAAA;EACA,uBAAA;AAhER;;AAoEA;EACI,eAAA;EACA,iBAAA;AAjEJ;;AAoEA;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cCniBI;EDoiBJ,kBAAA;EACA,qBAAA;EACA,gBAAA;AAjEJ;;AAoEA;EACI,kBAAA;AAjEJ;AAmEI;EACI,wBAAA;AAjER;;AAsEA;EACI,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,0BAAA;AAnEJ;AAwEI;EAVJ;IAWQ,gBAAA;EArEN;AACF;;AAwEA;EACI,eAAA;AArEJ;;AAwEA;EACI,0BAAA;AArEJ;;AA2EA;EACI;IAAI,mBAAA;EAvEN;EAwEE;IAAK,qBAAA;IAAuB,UAAA;EApE9B;EAqEE;IAAM,qBAAA;IAAuB,UAAA;EAjE/B;AACF;AAkEA;EACI;IAAI,qBAAA;IAAuB,UAAA;EA9D7B;EA+DE;IAAK,qBAAA;IAAuB,UAAA;EA3D9B;EA4DE;IAAM,mBAAA;EAzDR;AACF;AA2DA;EACI,mBAAA;AAzDJ;;AA6DI;EACI,kBAAA;AA1DR;AA2DQ;EACI,kBAAA;AAzDZ;AA4DI;EACI,gBAAA;EACA,qBAAA;AA1DR;AA4DQ;EACI,qBAAA;AA1DZ;AA6DQ;EACI,cC/lBC;ADoiBb;;AAgEA;EACI,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AA7DJ;AA+DI;EACI,cCvnBA;AD0jBR;;AAkEA;EACI,kBAAA;EACA,MAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;AA/DJ;AAiEI;EACI,YAAA;EACA,iBAAA;AA/DR;AAkEI;EACI,WAAA;EACA,kBAAA;AAhER;AE5hBI;EF8kBJ;IAkBQ,aAAA;EAhEN;AACF","sourcesContent":["@import 'variables';\r\n@import 'bootstrap/functions';\r\n@import 'bootstrap/variables';\r\n@import 'bootstrap/mixins';\r\n\r\n//start in work stuff muss noch ausgelagert werden wenn feSpecularLighting\r\n\r\n// .modal-open {\r\n// //    margin-right: var(--data-scrollbar-width);\r\n// }\r\n\r\n//end in work\r\n\r\n.centerAdd {\r\n    text-align: center;\r\n    padding: 20px 0px;\r\n}\r\n\r\n// below here not needed for 2nd element\r\n\r\n.news-text-container {\r\n    h2 {\r\n        font-size: 30px;\r\n        line-height: 46px;\r\n        color: $blue;\r\n        font-weight: normal;\r\n        margin: 48px 0px 37px;\r\n    }\r\n}\r\n\r\n// below here not needed for 3nd element\r\n.col-lg-6 {\r\n    padding-left: 0px;\r\n}\r\n\r\n.addLeft .col-lg-6 {\r\n    padding-left: 15px;\r\n}\r\n\r\n.addLeft,\r\n.addRight {\r\n    // The last element before `<div class=\"clearFloat\">`.\r\n    > :nth-last-child(2) {\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n\r\n.teaserConInner {\r\n    padding: 72px 65px 30px 40px;\r\n    background-image: url('../../img/langtext_teaser_gruen.svg');\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    background-position: right;\r\n    //background: linear-gradient(90deg, #3DBEA2 0%, #228D76 100%);\r\n    //background-size: 200%;\r\n    display: flex;\r\n    //position: absolute;\r\n    //left: 15px;\r\n    //right: -117px;\r\n    max-width: none;\r\n    width: auto;\r\n    justify-content: space-between;\r\n    transition: transform 0.4s;\r\n    //background-position-x: 0%;\r\n    // top: 0px;\r\n    position: relative;\r\n    transform: translateY(0);\r\n\r\n    &:before {\r\n        display: block;\r\n        content: '';\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        background-color: #000;\r\n        opacity: 0.1;\r\n        transition: opacity 0.4s;\r\n    }\r\n\r\n    @media (max-width: 1330px) {\r\n    //    right: 0px;\r\n        padding-right: 40px;\r\n    }\r\n    @media (max-width: 1060px) {\r\n        padding-right: 65px;\r\n    }\r\n    @media (max-width: 991px) {\r\n    //    position: relative;\r\n    //    left: 0px;\r\n    }\r\n    @media (max-width: 380px) {\r\n        padding: 72px 15px 30px 15px;\r\n    }\r\n\r\n    .seminarFakelink {\r\n        position: relative;\r\n        display: inline-block;\r\n        font-size: 24px;\r\n        line-height: 29px;\r\n        font-weight: bold;\r\n        margin-bottom: 23px;\r\n        margin-top: 22px;\r\n    }\r\n\r\n    .seminarFakelink:after {\r\n        position: absolute;\r\n        bottom: -10px;\r\n        left: 0;\r\n        content: '';\r\n        height: 2px;\r\n        width: 30%;\r\n        background-color: $white;\r\n        transition: width 0.4s;\r\n        display: block;\r\n    }\r\n\r\n    &:hover {\r\n        //background-position-x: 50%;\r\n        // top: -20px;\r\n        transform: translateY(-20px);\r\n\r\n        &:before {\r\n            opacity: 0;\r\n        }\r\n\r\n        .teaserImg {\r\n            transform: scale(1.02);\r\n        }\r\n\r\n        .seminarFakelink:after {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    &.leftImgTeaser {\r\n        gap: 75px;\r\n\r\n        @media (max-width: 1330px) {\r\n            gap: 40px;\r\n        }\r\n\r\n        @media (max-width: 1060px) {\r\n            gap: 75px;\r\n        }\r\n\r\n        @media (max-width: 550px) {\r\n            gap: 25px;\r\n            flex-wrap: wrap;\r\n        }\r\n    }\r\n}\r\n\r\n.addLeft .teaserConInner {\r\n    //background: linear-gradient(90deg, #228D76 0%, #3DBEA2 100%);\r\n    //background-position-x: 100%;\r\n    //background-size: 200%;\r\n    //transition: all 0.4s;\r\n    //right: 15px;\r\n    //left: -117px;\r\n\r\n    @media (max-width: 1330px) {\r\n    //    left: 0px;\r\n    }\r\n    @media (max-width: 991px) {\r\n    //    position: relative;\r\n    //    right: 0px;\r\n    //    margin-bottom: 30px;\r\n    }\r\n    @media (max-width: 550px) {\r\n        flex-wrap: wrap;\r\n    }\r\n}\r\n\r\n.teaserCon {\r\n    float: right;\r\n    width: calc(50% + 177px);\r\n    margin-right: -117px;\r\n    padding-left: 80px;\r\n    padding-bottom: 20px;\r\n\r\n    @media (max-width: 1330px) {\r\n        width: calc(50% + 60px);\r\n        margin-right: 0px;\r\n    }\r\n    @media (max-width: 1170px) {\r\n        width: calc(50% + 10px);\r\n        padding-left: 30px;\r\n        padding-bottom: 0px;\r\n    }\r\n    @media (max-width: 1060px) {\r\n        float: none;\r\n        padding-left: 0px;\r\n        width: 100%;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    svg {\r\n        position: absolute;\r\n        z-index: -1;\r\n    }\r\n}\r\n\r\n.teaserLeftImgWrap {\r\n    position: relative;\r\n\r\n    .flags {\r\n        display: flex;\r\n        flex-direction: column;\r\n        position: absolute;\r\n        top: -35px;\r\n        right: -35px;\r\n        color: #fff;\r\n        z-index: 10;\r\n\r\n        .flag {\r\n            margin-bottom: 10px;\r\n        }\r\n    }\r\n\r\n    .teaserImg {\r\n        min-width: 193px;\r\n        padding-bottom: 30px;\r\n\r\n        @media (max-width: 1200px) {\r\n            min-width: 123px;\r\n        }\r\n\r\n        @media (max-width: 1060px) {\r\n            min-width: 193px;\r\n        }\r\n\r\n        @media (max-width: 600px) {\r\n            min-width: 123px;\r\n        }\r\n\r\n        @media (max-width: 400px) {\r\n            min-width: 193px;\r\n        }\r\n    }\r\n}\r\n\r\n.leftImgTeaser {\r\n    p {\r\n        font-size: 18px;\r\n        line-height: 30px;\r\n        margin-bottom: 12px;\r\n    }\r\n\r\n    .greenText,\r\n    .productPrice {\r\n        color: $white;\r\n    }\r\n}\r\n\r\n.addLeft .teaserCon {\r\n    float: left;\r\n    margin-right: 0px;\r\n    margin-left: -117px;\r\n    padding-left: 0px;\r\n    padding-right: 80px;\r\n\r\n    @media (max-width: 1330px) {\r\n        width: calc(50% + 60px);\r\n        margin-left: 0px;\r\n    }\r\n    @media (max-width: 1170px) {\r\n        width: calc(50% + 10px);\r\n        padding-right: 30px;\r\n        padding-bottom: 0px;\r\n    }\r\n    @media (max-width: 1060px) {\r\n        float: none;\r\n        padding-right: 0px;\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.teaserContent {\r\n    align-self: end;\r\n    margin-right: 30px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    color: $white;\r\n    max-width: 100%;\r\n\r\n    .teaserLeftImgWrap + & {\r\n        padding-bottom: 30px;\r\n\r\n        @media (max-width: 550px) {\r\n            padding-bottom: 0;\r\n        }\r\n    }\r\n\r\n    h4 {\r\n        font-size: 30px;\r\n        line-height: 36px;\r\n        font-weight: normal;\r\n    }\r\n\r\n    .flagSeminar {\r\n        margin-top: 50px;\r\n    }\r\n\r\n    .shortText {\r\n        font-size: 18px;\r\n        line-height: 30px;\r\n    }\r\n\r\n    .date,\r\n    .meta {\r\n        font-size: 16px;\r\n        line-height: 24px;\r\n\r\n        &:before {\r\n            content: '\\ec30';\r\n            font-family: 'LineIcons';\r\n            padding-right: 7px;\r\n            font-size: 20px;\r\n            position: relative;\r\n            top: 5px;\r\n        }\r\n    }\r\n\r\n    .date:before {\r\n        content: '\\ea2e';\r\n        top: 4px;\r\n    }\r\n\r\n    .meta:before {\r\n        content: '\\ec8f';\r\n        top: 4px;\r\n    }\r\n\r\n    .meta {\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    .date {\r\n        margin-bottom: 16px;\r\n    }\r\n}\r\n\r\n.teaserCon .teaserConInner:hover {\r\n    &:after {\r\n        content: '';\r\n        background-color: transparent;\r\n        height: 20px;\r\n        width: 100%;\r\n        display: block;\r\n        position: absolute;\r\n        bottom: -20px;\r\n        left: 0px;\r\n    }\r\n}\r\n\r\n.topicHeader,\r\n.topTipp {\r\n    font-size: 16px;\r\n    line-height: 20px;\r\n    margin-bottom: 4px;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.teaserImg {\r\n    max-width: 193px;\r\n    padding-bottom: 42px;\r\n    width: 100%;\r\n    transition: transform 0.4s;\r\n\r\n    @media (max-width: 550px) {\r\n        // margin-top: 20px;\r\n    }\r\n}\r\n\r\n.teaserImgWrap {\r\n    position: absolute;\r\n    top: 30px;\r\n    right: 30px;\r\n    height: 170px;\r\n    width: 170px;\r\n    border-radius: 50%;\r\n    overflow: hidden;\r\n    display: flex;\r\n    justify-content: center;\r\n\r\n    @media (max-width: 380px) {\r\n        right: 15px;\r\n    }\r\n\r\n    img {\r\n        max-width: none;\r\n        max-height: 100%;\r\n    }\r\n}\r\n\r\n.news-related-links a,\r\n.news-related-files-link a {\r\n    margin-right: 10px;\r\n}\r\n\r\n// below here continue reading\r\n.toContinueReading {\r\n    position: relative;\r\n    min-height: 1045px;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.toContinueReading:after {\r\n    content: '';\r\n    // darf nicht transperent sein muss für iOS rgba sein\r\n    background-image: linear-gradient(0deg, $white 30%, rgba(255, 255, 255, 0) 100%);\r\n    position: absolute;\r\n    height: 850px;\r\n    width: 100%;\r\n    display: block;\r\n    // top: 0;\r\n    bottom: 0;\r\n}\r\n\r\n#main .toContinueReadingModal,\r\n.toContinueReadingModal {\r\n    position: absolute;\r\n    // top: 300px;\r\n    bottom: 0;\r\n    z-index: 5;\r\n    background: white;\r\n    box-shadow: $body-color 0px 0px 30px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    // padding: 78px 145px 40px;\r\n    width: 100%;\r\n    max-width: 800px;\r\n    display: flex;\r\n    justify-content: center;\r\n    z-index: 11;\r\n    padding: 78px 15px 40px 15px;\r\n\r\n    @media (max-width: 480px) {\r\n        padding: 48px 15px 40px;\r\n        // max-width: 100%;\r\n    }\r\n\r\n    h4 {\r\n        font-size: 30px;\r\n        line-height: 46px;\r\n        color: $blue;\r\n        font-weight: normal;\r\n        margin-bottom: 34px;\r\n        text-align: left;\r\n        // width: max-content;\r\n\r\n        // @media (max-width: 480px) {\r\n        //     width: calc(100vw - 30px);\r\n        // }\r\n    }\r\n\r\n    img {\r\n        height: 25px;\r\n        width: auto;\r\n        position: relative;\r\n        top: -2px;\r\n        padding-left: 10px;\r\n\r\n        @media (max-width: 460px) {\r\n            padding-left: 0px;\r\n        }\r\n    }\r\n\r\n    li {\r\n        font-size: 18px;\r\n        line-height: 30px;\r\n        padding-left: 35px !important;\r\n        text-align: left;\r\n\r\n        @media (max-width: 480px) {\r\n            display: inline-block;\r\n        }\r\n    }\r\n\r\n    ul li:before {\r\n        content: none;\r\n    }\r\n\r\n    span:not(.underline):not(.check) {\r\n        display: block;\r\n        width: 100%;\r\n        text-align: center;\r\n    }\r\n\r\n    &.toContinueWatchingModal {\r\n        bottom: 50%;\r\n        opacity: 1;\r\n        transform: translateX(-50%) translateY(50%);\r\n        transition: all 300ms;\r\n\r\n        &.hidden {\r\n            opacity: 0;\r\n            transform: translateX(-250%) translateY(50%);\r\n        }\r\n    }\r\n}\r\n\r\n.check {\r\n    display: inline-block;\r\n    position: absolute;\r\n    top: 1px;\r\n    left: 5px;\r\n    width: 10px !important;\r\n    height: 20px;\r\n    border-bottom: 2px solid;\r\n    border-right: 2px solid;\r\n    transform: rotate(45deg);\r\n    color: #005790;\r\n    background-color: transparent;\r\n}\r\n\r\n.underline {\r\n    position: relative;\r\n\r\n    &:after {\r\n        content: '';\r\n        position: absolute;\r\n        left: 0px;\r\n        bottom: -3px;\r\n        height: 1px;\r\n        width: 100%;\r\n        background-color: $green;\r\n    }\r\n}\r\n\r\n.continueAboPrice {\r\n    font-size: 38px;\r\n    line-height: 46px;\r\n    color: $blue;\r\n    margin-top: 46px;\r\n}\r\n\r\n.continuePerMonth {\r\n    font-size: 18px;\r\n}\r\n\r\n.continueAboButton {\r\n    background: $green;\r\n    background-image: linear-gradient(270deg, #3DBEA2 50%, #228D76 100%);\r\n    background-size: 200%;\r\n    background-position: 100%;\r\n    transition: all 0.4s;\r\n    // transition: color 0.4s, background-position 0.4s;\r\n    padding: 20px;\r\n    margin: 32px 0px 28px;\r\n    display: block;\r\n    text-align: center;\r\n    color: white;\r\n    font-size: 18px;\r\n    line-height: 30px;\r\n    font-weight: bold;\r\n\r\n    &:hover {\r\n        color: white;\r\n        background-position: 0%;\r\n    }\r\n}\r\n\r\n.continueAlreadyAbo{\r\n    font-size: 18px;\r\n    line-height: 30px;\r\n}\r\n\r\n.continueLogin {\r\n    font-size: 18px;\r\n    line-height: 30px;\r\n    font-weight: bold;\r\n    color: $green;\r\n    text-align: center;\r\n    display: inline-block;\r\n    margin-top: 10px;\r\n}\r\n\r\n.toContinueReadingModalInner {\r\n    text-align: center;\r\n\r\n    li:before {\r\n        display: none !important;\r\n    }\r\n}\r\n\r\n// authoren modal\r\n#authorModal .modal-content {\r\n    max-width: 724px;\r\n    background: white;\r\n    padding: 70px 15px 15px;\r\n    margin: 40px auto 0px;\r\n    transition: transform 0.3s;\r\n    //transform: scale(0);\r\n    //animation-name: scaleDown;\r\n    //animation-duration: 0.3s;\r\n\r\n    @media (max-width: 576px) {\r\n        margin: 0px auto;\r\n    }\r\n}\r\n\r\n#authorModal .modal-dialog {\r\n    transform: none;\r\n}\r\n\r\n.authorOpen #authorModal .modal-content {\r\n    transition: transform 0.3s;\r\n    //transform: scale(1);\r\n    //animation-name: scaleUp;\r\n    //animation-duration: 0.31s;\r\n}\r\n\r\n@keyframes scaleDown {\r\n    0% {transform: scale(1);}\r\n    90% {transform: scale(0.1); opacity: 1;}\r\n    100% {transform: scale(0.1); opacity: 0;}\r\n}\r\n@keyframes scaleUp {\r\n    0% {transform: scale(0.1); opacity: 0;}\r\n    10% {transform: scale(0.1); opacity: 1;}\r\n    100% {transform: scale(1);}\r\n}\r\n\r\n.closeAuthor {\r\n    margin: 0 auto 70px;\r\n}\r\n\r\n.author {\r\n    .photo {\r\n        text-align: center;\r\n        img {\r\n            border-radius: 50%;\r\n        }\r\n    }\r\n    .description {\r\n        max-width: 465px;\r\n        margin: 0px auto 40px;\r\n\r\n        .authorName {\r\n            margin: 28px 0px 23px;\r\n        }\r\n\r\n        p {\r\n            color: $body-color;\r\n        }\r\n    }\r\n}\r\n\r\n.toggleLinkAuthor {\r\n    border-bottom: solid $green 1px;\r\n    padding-bottom: 2px;\r\n    cursor: pointer;\r\n    transition: color 0.4s;\r\n\r\n    &:hover {\r\n        color: $green;\r\n    }\r\n}\r\n\r\n\r\n.advertisementTeaserContainer {\r\n    position: relative;\r\n    top: 0;\r\n    transition: top 400ms;\r\n    width: 300px;\r\n    margin-bottom: 20px;\r\n\r\n    &.right {\r\n        float: right;\r\n        margin-left: 50px;\r\n    }\r\n\r\n    &.left {\r\n        float: left;\r\n        margin-right: 50px;\r\n    }\r\n\r\n    @include media-breakpoint-down(sm) {\r\n        display: none;\r\n    }\r\n}\r\n\r\n// #newsVideoModal {\r\n//     .modal-content {\r\n//         max-width: 1000px;\r\n//         margin: 0 auto;\r\n//         padding: 70px 25px 25px;\r\n//         background-color: #fff;\r\n//     }\r\n\r\n//     // Play button over video\r\n//     .plyr__control--overlaid {\r\n//         width: 100px;\r\n//         height: 100px;\r\n//         padding: 0 0 0 10px;\r\n//         opacity: 1;\r\n\r\n//         &:hover {\r\n//             background-color: $green-dark;\r\n//         }\r\n\r\n//         svg {\r\n//             display: none;\r\n//         }\r\n\r\n//         &:before {\r\n//             position: relative;\r\n//             z-index: 1;\r\n//             display: block;\r\n//             font-family: LineIcons;\r\n//             content: '\\f0e7';\r\n//             font-size: 60px;\r\n//             line-height: 1;\r\n//         }\r\n\r\n//         &:after {\r\n//             display: block;\r\n//             content: '';\r\n//             position: absolute;\r\n//             top: 0;\r\n//             left: 0;\r\n//             width: 100px;\r\n//             height: 100px;\r\n//             border-radius: 50%;\r\n//             background: linear-gradient(270deg, $green 0%, $green-dark 100%);\r\n//             opacity: 0;\r\n//             transition: opacity $transition-duration ease-out;\r\n//         }\r\n\r\n//         &:hover:after {\r\n//             opacity: 1;\r\n//         }\r\n//     }\r\n// }","//\r\n// Project specific variables\r\n// --------------------------------------------------\r\n\r\n//== Transitions\r\n$transition-duration: 300ms !default;\r\n$transition-duration-fast: 150ms !default;\r\n\r\n$page-width:     1600px;\r\n$page-min-width:  320px;\r\n$content-width:  1420px;\r\n\r\n//\r\n// Bootstrap variables\r\n// --------------------------------------------------\r\n\r\n//== Color system\r\n$white: #ffffff;\r\n$gray-100: #f8f7f4;\r\n$gray-200: #ece9e4;\r\n$gray-300: #e0ddd6;\r\n$gray-400: #001f37;\r\n\r\n$blue: #005790;\r\n$blue-light: #aebacc;\r\n$blue-dark: #003151;\r\n$blue-medium: #004471;\r\n$green: #3dbea2;\r\n$green-dark: #228d76;\r\n$red: #ea7c7c;\r\n$red-light: #ed8f8f;\r\n$brown: #d8bc91;\r\n\r\n$primary: $blue;\r\n$secondary: $green;\r\n\r\n\r\n\r\n//== Body\r\n$body-color: #5f5e5c;\r\n\r\n//== Components\r\n$line-height-base: 1.7;\r\n$line-height-lg: 1.7;\r\n$line-height-sm: 1.7;\r\n\r\n//== Fonts\r\n$font-size-base: 1.25rem; // If we don't use rem, we get compile errors...\r\n\r\n//== Fonts\r\n$font-family-sans-serif: 'Gudea', sans-serif;\r\n\r\n$h1-font-size:   38px;\r\n$h1-line-height: 46px;\r\n\r\n$h2-font-size:   30px;\r\n$h2-line-height: 46px;\r\n\r\n// $h3-font-size:   20px;\r\n// $h3-line-height: 30px;\r\n\r\n//== Links\r\n$link-hover-decoration: none;\r\n\r\n$fullwidth-margin-desktop: 120px;\r\n// $fullwidth-margin-desktop: 90px;\r\n$fullwidth-margin-tablet: 70px;\r\n$fullwidth-margin-smartphone: 60px;\r\n\r\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02px, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
